import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MerchHero } from '../components/merch/MerchHero';
import { ProductGrid } from '../components/merch/ProductGrid';
export function MerchPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-998">
      <Header data-id="element-999" />

      <main className="pt-20" data-id="element-1000">
        <MerchHero data-id="element-1001" />
        <ProductGrid data-id="element-1002" />
      </main>

      <Footer data-id="element-1003" />
    </div>;
}